import { render, staticRenderFns } from "./jumpConfig.vue?vue&type=template&id=1b5edf6f&scoped=true"
import script from "./jumpConfig.vue?vue&type=script&lang=js"
export * from "./jumpConfig.vue?vue&type=script&lang=js"
import style0 from "./jumpConfig.vue?vue&type=style&index=0&id=1b5edf6f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5edf6f",
  null
  
)

export default component.exports